import type { TUnionType } from './models';

/**
 * Разбивает числа на тысячи (1000000.01 -> 1 000 000,01), приводя их к стандарту ru-RU
 * @param value - Значение для форматирования
 * @param options - Опции для функции `toLocaleString`
 */
export const separateThousands = (
    rawValue: TUnionType,
    options: Intl.NumberFormatOptions = {
        maximumFractionDigits: 10,
    }
) => {
    const value = (rawValue ?? '')
        .toString()
        .replace(',', '.')
        .replace(/\u00a0/g, '');

    if (!value || Number.isNaN(Number(value))) return '';

    return Number(value).toLocaleString('ru-RU', options);
};
